// @flow

import { pickupDashboardActions } from './pickupDashboardActionCreator';

const initialState = {
  isLoading: false,
  isLoaded: false,
  dashboardData: [],
  dashboardDataFiltered: [],
  deletePickupInitiated: null,
  deletePickupDone: null,
  error: null,
  pickupDeleteReasons: [],
  locationList: [],
  clusterList: []
};

const filterDashboardTableData = (newState, searchStr) => {
  const searchString = searchStr.toLowerCase().trim();

  let filteredArr;

  if (searchString) {
    filteredArr = newState.dashboardData.filter(
      row =>
        (row.id &&
          row.id.toString() &&
          row.id
            .toString()
            .toLowerCase()
            .indexOf(searchString) >= 0) ||
        (row.bpAssigned &&
          row.bpAssigned.toLowerCase().indexOf(searchString) >= 0) ||
        (row.clientName &&
          row.clientName.toLowerCase().indexOf(searchString) >= 0) ||
        (row.consignorName &&
          row.consignorName.toLowerCase().indexOf(searchString) >= 0) ||
        (row.contactPerson &&
          row.contactPerson.toLowerCase().indexOf(searchString) >= 0) ||
        (row.detailedAddress &&
          row.detailedAddress.toLowerCase().indexOf(searchString) >= 0) ||
        (row.locationName &&
          row.locationName.toLowerCase().indexOf(searchString) >= 0) ||
        (row.remarks && row.remarks.toString().indexOf(searchString) >= 0)
    );
  } else {
    filteredArr = newState.dashboardData;
  }

  return filteredArr;
};

const pickupDashboardReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case pickupDashboardActions.SET_PICKUP_DASHBOARD_DATE_RANGE: {
      return Object.assign({}, state, action.payload);
    }
    case pickupDashboardActions.GET_DASHBOARD_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case pickupDashboardActions.DELETE_PICKUP: {
      return Object.assign({}, state, action.payload);
    }
    case pickupDashboardActions.GET_PICKUP_DELETE_REASONS: {
      return Object.assign({}, state, action.payload);
    }
    case pickupDashboardActions.FILTER_DASHBOARD_DATA: {
      const newState = Object.assign({}, state);
      const filtered = filterDashboardTableData(newState, action.payload);
      return Object.assign({}, state, { dashboardDataFiltered: filtered });
    }
    case pickupDashboardActions.GET_REPORTING_LOCATIONS: {
      const allobj = { code: 'ALL', pincode: 'ALL', id: null };
      if (
        action.payload &&
        action.payload &&
        action.payload.locationList &&
        action.payload.locationList.indexOf(allobj) === -1
      ) {
        // let locationList = action.payload.locationList.map(function(elem){
        //   elem.pincode = elem?.addressDTO?.pincode;
        // })
        // if (locationList) {
        //   action.payload.locationList = locationList;
        // }
        // for(let elem of action.payload.locationList) {
        //   elem.pincode = elem.addressDTO.pincode;
        // }
        action.payload.locationList.unshift({
          code: 'ALL',
          pincode: 'ALL',
          id: null
        });
      }
      return Object.assign({}, state, action.payload);
    }

    case pickupDashboardActions.GET_REPORTING_CLUSTERS: {
      let clusterList = [];
      clusterList = (action.payload.clusterList || []).map(cluster => {
        return { clusterCode: cluster, clusterName: cluster };
      });

      clusterList.unshift({ clusterCode: null, clusterName: 'ALL' });

      return Object.assign({}, state, { clusterList: clusterList });
    }
    default: {
      return state;
    }
  }
};

export default pickupDashboardReducer;
